<template>
    <div id="contenedor-main-proyectos-tablero">
        <ProyectoTablero :id-proyecto="idProyecto"></ProyectoTablero>
    </div>
</template>

<script>
import ProyectoTablero from '@/components/administracion/control-proyectos/tablero/Main.vue';

export default {
  components: {
    ProyectoTablero,
  },
  data() {
    return {
      idProyecto: this.$route.params.idProyecto,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
